function ColorHelper(){

}

ColorHelper.prototype.hexToRGB = function(_color){
    _color = _color.replace("#", "")
    let color = {}
    color.red = parseInt(_color.substring(0,2),16) / 255;
    color.green = parseInt(_color.substring(2,4),16) / 255;
    color.blue = parseInt(_color.substring(4),16) / 255;
    return color
}

export default new ColorHelper()


// WEBPACK FOOTER //
// ./src/components/export-google-sheet/helpers/color/index.js